var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconFileName.indexOf('el-icon-') === 0)?_c('i',{class:_vm.iconFileName}):_c('svg',_vm._g({staticClass:"svg-icon",attrs:{"aria-hidden":"true"}},_vm.$listeners),[_c('use',{attrs:{"xlink:href":`#icon-${_vm.iconFileName}`,"rel":"external nofollow"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }